import { Box, Chip, Tooltip } from "@mui/material";
import { pctFmt } from "../types";

export function getSecuredPctColor(percentage: number): string {
  const isExact = Math.abs(percentage - 100) < 0.1;
  const isOver = percentage > 100;
  if (isExact) return "#4caf50";
  if (isOver) return "#d32f2f";
  return "#ed6c02";
}

export function SecuredIndicator({
  percentage,
}: {
  percentage: number | null;
}) {
  if (percentage === null) return null;
  const isOver = percentage > 100;
  const isExact = Math.abs(percentage - 100) < 0.1;

  const color: "success" | "error" | "warning" = isExact
    ? "success"
    : isOver
      ? "error"
      : "warning";

  return (
    <Box sx={{ display: "flex", justifyContent: "center", mt: 0.25 }}>
      <Tooltip
        title="Andel av prognos/förbrukning som är säkrad"
        arrow
        placement="bottom"
      >
        <Chip
          label={`${pctFmt.format(percentage)}%`}
          color={color}
          size="small"
          variant="outlined"
          sx={{
            height: 20,
            fontSize: "0.7rem",
            cursor: "default",
          }}
        />
      </Tooltip>
    </Box>
  );
}
